// constants
export const API_PATH = '/api';

export const Alarm = {
    HiHi: 'HiHi',
    LoLo: 'LoLo',
    Hi: 'Hi',
    Lo: 'Lo',
    Watchdog: 'Watchdog',
    NoRecentData: 'NoRecentData',
    RTUBackoff: 'RTUBackoff',
    RTUDisconnected: 'RTUDisconnected',
    RTUUnknown: 'RTUUnknown',
    None: 'None'
}

export const AssetTypes = {
    Battery: 'BATTERY',
    Client: 'ORG_UNIT1',
    Company: 'COMPANY',
    Completion: 'COMPLETION',
    Facility: 'BATTERY',
    Field: 'ORG_UNIT4',
    Country: 'ORG_UNIT3',
    SCB: 'SCB'
};

export const AcquisitionProtocol = {
    ION_SPECIFIC: 'ION_SPECIFIC',
    MODBUS: 'MODBUS'
};

export const AssetLevels = {
    COMPANY: 0,
    ORG_UNIT1: 1,   // client
    ORG_UNIT3: 2,   // country
    ORG_UNIT4: 3,   // field
    BATTERY: 4,     // facility/pad
    COMPLETION: 5
};

export const AssetFriendlyNames = {
    BATTERY: 'Pad',
    ORG_UNIT1: 'Client',
    COMPANY: 'Company',
    COMPLETION: 'Well',
    ORG_UNIT4: 'Field',
    ORG_UNIT3: 'Country'
};

export const ContentType = {
    Json: 'application/json;charset=UTF-8',
    Form: 'application/x-www-form-urlencoded;charset=UTF-8'
};

export const ColorClasses = {
    Accent: 'accent',
    AccentBg: 'accent-bg',
    ActiveBg: 'active-bg',
    Blue: 'blue-color',
    BlueBg: 'blue-bg',
    Border: 'border-color',
    Green: 'green',
    Red: 'red',
    RedBg: 'red-bg',
    RedBorder: 'red-border',
    Yellow: 'yellow',
    YellowBg: 'yellow-bg',
    YellowBorder: 'yellow-border'
};

export const Colors = {
    Changed: '#FFF9C4',
    Error: '#d34c4b',
    Warning: '#edbc50'
};

export const DataTransmissionStatus = {
    HIBERNATE: 'HIBERNATE',
    OFFLINE: 'OFFLINE',
    ONLINE: 'ONLINE'
};

export const EventTypes = {
    ValAlarmLimit: 'VAL_ALM_LIMIT',
    WDAlarmLimit: 'VAL_ALM_WD'
};

export const SignalR = {
    KeepAliveInterval: 60000,   // 1 minute
    EventTimer: 5000,           // 5 seconds
    Url: window.location.protocol + '//' + window.location.host + `${API_PATH}/signalR`
};

export const LocalStorageKeys = {
    Colors: 'lmweb-color-map'
};

let Constants = {
    ApiPath: `${API_PATH}`,
    ChartFontFamily: 'Roboto',
    DateFormat: 'DD-MMM-YYYY',
    DateTimeFormat: 'DD-MMM-YYYY HH:mm:ss',
    DefaultPageSize: 5,
    Icons: {
        Edit: 'AL-icon--edit',
        Remove: 'AL-icon--remove',
        Save: 'AL-icon--save',
        Undo: 'AL-icon--undo',
        Info: 'AL-icon--info'
    },
    ClassNames: {
        Tooltip: 'AL-tooltip',
        TooltipLeft: 'AL-tooltip AL-tooltip--left',
        TooltipRight: 'AL-tooltip AL-tooltip--right',
        TooltipBottom: 'AL-tooltip AL-tooltip--bottom',
        InputValidationError: 'AL-input-validation-error',
        InputError: 'AL-input-error'
    },
    SystemUser: 'SYSTEM'
};

export const PROD_DATA_TRANSACTION_TYPE = 'PROD_DATA';

export const Roles = {
    Administrator: 'Administrator',
    AvalonMigration: 'Avalon Migration',
    ClientBasic: 'Client Basic Access',
    ClientControl: 'Client Control Access',
    ClientSurveillance: 'Client Surveillance',
    INTERNAL_AE_Basic: 'INTERNAL AE Basic Access',
    INTERNAL_AE_Remote_Ctrl: 'INTERNAL AE Remote Control',
    INTERNAL_AE_Remote_Prov: 'INTERNAL AE Remote/PROV',
    INTERNAL_Surveillance_Basic: 'INTERNAL Surveillance Basic',
    INTERNAL_Surveillance_Control: 'INTERNAL Surveillance Control',
    INTERNAL_Surveillance_Lead: 'INTERNAL Surveillance Lead',
    // not used
    DeploymentEngineer: 'Deployment Engineer',
    ReadOnlyUser: 'Read Only User',
    Super: 'Super',
    SurveillanceEngineer: 'Surveillance Engineer',
};

export const UnusedRoles = [
    'Deployment Engineer',
    'Read Only User',
    'Super',
    'Surveillance Engineer',
];

export const ServiceLevels = [
    { text: '', value: null },
    { text: 'Level 1', value: 1 },
    { text: 'Level 2', value: 2 },
    { text: 'Level 3', value: 3 },
];

export default Constants;
